'use client';
import { ProductReference, ShopifyDiscount } from "lib/shopify/types";
import { AddonItem } from "./addon-item";

export function AddonItemBox({collectionHandle, addons, discount, productDiscounts}: {collectionHandle: string, addons: ProductReference[], discount: number, productDiscounts: ShopifyDiscount[]}) {
    const findProductDiscountByCollection = collectionHandle ? productDiscounts.find(discount => discount.customerGets?.items?.collections?.edges.find(product => product.node.handle === collectionHandle)) :
    productDiscounts.find(discount => discount.customerGets?.items?.collections?.edges.find(product => product.node.handle === 'best-sellers'))
    const collectionDiscountByPercentage = findProductDiscountByCollection?.customerGets?.value?.percentage ?? 0
    const collectionDiscountByAmount = findProductDiscountByCollection?.customerGets?.value?.amount?.amount ?? 0
    const collectionDiscounts = {
        percentage: collectionDiscountByPercentage,
        amount: Number(collectionDiscountByAmount)
    }
    const hasDiscount = collectionDiscounts.percentage > 0 || collectionDiscounts.amount > 0
    const discountValue = collectionDiscountByPercentage > 0 ? collectionDiscountByPercentage * 100 : collectionDiscounts.amount > 0 ? collectionDiscounts.amount : 0
    return (
        <div className="flex flex-col">
            <div className="text-fp-gray text-base mt-4">Add more items to your cart {hasDiscount && <span className="text-fp-green">- {discountValue}{collectionDiscountByPercentage > 0 ? '%' : ''} Off Applied</span>}</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            {!addons ? <div>No addons available</div> : addons.map((addon) => (
                    <AddonItem key={addon.id} collectionHandle={collectionHandle} addon={addon} discount={discount} collectionDiscounts={collectionDiscounts} productDiscounts={productDiscounts}/>
                ))}
            </div>
        </div>
    )
}
